import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { translation } from '@cue/translations';
import { cueDelete, cueInfo, IconComponent } from '@cue/ui/icons';
import { TooltipDirective } from '@cue/ui/tooltips';
import { TranslocoPipe } from '@jsverse/transloco';
import { NewReservationResourceRow } from '../new-reservation-dialog.models';

@Component({
  selector: 'assist-new-reservation-location-row',
  templateUrl: './new-reservation-location-row.component.html',
  styleUrl: './new-reservation-location-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TooltipDirective, TranslocoPipe],
})
export class NewReservationLocationRowComponent {
  readonly row = input.required<NewReservationResourceRow>();
  readonly changeLocation = output<number>();
  readonly removeLocation = output<number>();

  readonly translation = translation;
  readonly icons = {
    cueDelete,
    cueInfo,
  };

  onChangeLocation(event: Event) {
    event.preventDefault();
    this.changeLocation.emit(this.row().resource.idForFiltering);
  }

  onRemoveLocation(event: Event) {
    event.preventDefault();
    this.removeLocation.emit(this.row().resource.idForFiltering);
  }
}
